import styled from 'styled-components';
import { colors } from '../colors';

const SidebarListItems = styled.li`
	min-height: 48px;
	list-style: none;
	white-space: nowrap;
	a {
		display: flex;
		align-items: center;
		color: #645e7a;
		transition: ease-in all 0.4s;
		cursor: pointer;
		text-decoration: none;
		overflow: hidden;
		padding: 0 24px;
		min-width: 180px;
		justify-content: center;
		span {
			display: inline-block;
			text-align: center;
			height: 100%;
			padding: 17px 10px 17px 0;
			font-size: 17px;
			text-decoration: none;
		}
		:hover {
			background: #00b2ad;
			color: ${colors.White};
			span {
				color: ${colors.White};
			}
		}
	}
	> div {
		width: 100%;
		diaplay: flex;
		align-items: center;
	}
	${({ active }) => active && `background: #00b2ad!important;a{color: ${colors.White}}`}
	${({ SubMenu }) =>
		SubMenu &&
		`
    display: flex;
        align-items: center;
        color: ${colors.White};
        transition: ease-in all 0.4s;
        cursor: pointer;
        margin-bottom: 1px;
        text-decoration:none;
        overflow: hidden;
        span{
            display: inline-block;
            width: 62px;
            text-align: center;
            height: 100%;
            padding: 17px 24px;
			text-decoration:none;
			font-size:17px;
            color: ${colors.White};
        }
        :hover{
            background: #00b2ad;
            color: ${colors.White};
            span{
                color: ${colors.White};
            }
        }
    `}
`;

export default SidebarListItems;
